import { useGlobal } from '@/utils/useGlobal';
import { Collapse } from 'antd';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';
import { useEffect } from 'react';

export default function J() {
    const { useLang, useState, useRouter } = useGlobal();
    const { t } = useLang('dp3.landing.faq');
    const { locale } = useRouter();
    const [active, setActive] = useState(0);

    const lists: any = [
        {
            title: t('list1_title'),
            desc: t('list1_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1764300482601/Frame%201612707578.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1764300482771/Frame%201612707580.jpg',
        },
        {
            title: t('list2_title'),
            desc: t('list2_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1764300484124/Frame%202094654245.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1764300483670/Frame%202094654247.jpg',
        },
        {
            title: t('list3_title'),
            desc: t('list3_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1764300484462/Frame%202094654246.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1764300483248/Frame%202094654248.jpg',
        },
    ];

    const tipKeys = ['tip_desc1'];
    const [load, setLoad] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const secne = AniContainer.create({
                triggerElement: '#TabSwriper',
                triggerHook: 1,
                onEnter: () => setLoad(true),
            });
            return () => {
                secne.destroy();
            };
        }
    }, []);
    return (
        <div className={`faq ${styles.faq} GtmModuleData-section`} data-section-id={'dp3-FAQ'} data-section-title={'dp3-FAQ'} id="FAQ">
            <EcoSectionCommon
                title={t.rich('title', {
                    sup: (text: any) => <span className="wrap">{text}</span>,
                })}
            />
            <EcoSpaceSmall />
            <div className={`eco-content ${styles.faq}`}>
                <div className="box-container">
                    <div className="card-box">
                        <div className="card-inner">
                            <Collapse
                                ghost={true}
                                className="collapse-lists"
                                defaultActiveKey={0}
                                onChange={setActive}
                                accordion={true}
                                expandIcon={({ isActive }: any) => {
                                    return (
                                        <svg
                                            className="collapse-icon"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="25"
                                            height="25"
                                            viewBox="0 0 25 25"
                                            fill="none"
                                        >
                                            <path
                                                d="M12.5 22.5C18.0228 22.5 22.5 18.0228 22.5 12.5C22.5 6.97715 18.0228 2.5 12.5 2.5C6.97715 2.5 2.5 6.97715 2.5 12.5C2.5 18.0228 6.97715 22.5 12.5 22.5Z"
                                                stroke="#757575"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M8.5 11.5L12.5 15.5L16.5 11.5"
                                                stroke="#757575"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    );
                                }}
                                expandIconPosition="right"
                            >
                                {lists?.map((list: any, k: number) => (
                                    <Collapse.Panel className="list-title" key={k} header={list.title}>
                                        <div className="list-img">
                                            {load && <EcoImg pc={list.pc} h5={list.h5} />}
                                        </div>
                                        <p className="list-desc">{list.desc}</p>
                                    </Collapse.Panel>
                                ))}
                            </Collapse>
                        </div>
                    </div>
                    <div className="img-box">
                        {load && <EcoImg pc={lists[active].pc} h5={lists[active].h5} />}
                    </div>
                </div>
                <div className="tip-container">
                    {tipKeys.map((key, index) => (
                        <div className="tip" key={index}>
                            {t.rich(key, {
                                sup: (tx: string) => <span className="number">{tx}</span>,
                            })}
                        </div>
                    ))}
                </div>
                {/* <div className="tip">{t('tip')}</div> */}
            </div>
        </div>
    );
}
